import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeZeroWaste: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.94658 4.97697H12.3082C12.5545 4.97697 12.7548 4.77664 12.7548 4.53039C12.7548 4.28413 12.5545 4.0838 12.3082 4.0838H10.7334V3.64355C10.7334 2.98205 10.1952 2.44385 9.53372 2.44385H6.72115C6.0596 2.44385 5.52142 2.98205 5.52142 3.64355V4.0838H3.94658C3.70033 4.0838 3.5 4.28416 3.5 4.53039C3.5 4.77664 3.70033 4.97697 3.94658 4.97697ZM9.84021 4.0641H6.4146L6.41461 3.64355C6.41461 3.47453 6.55211 3.33701 6.72115 3.33701H9.53369C9.70271 3.33701 9.84021 3.47453 9.84021 3.64355V4.0641Z"
        fill="black"
      />
      <path
        d="M5.95886 11.8826C5.97433 12.1165 6.16988 12.2997 6.40404 12.2997C6.41394 12.2997 6.4239 12.2994 6.43391 12.2987C6.67964 12.2825 6.86632 12.0694 6.85008 11.8237L6.59668 7.98946C6.58057 7.74568 6.36894 7.55719 6.12163 7.57329C6.00261 7.58117 5.89375 7.6349 5.81516 7.72464C5.73656 7.81438 5.6976 7.92933 5.70546 8.04837L5.95886 11.8826Z"
        fill="black"
      />
      <path
        d="M7.68091 11.8532C7.68091 12.0995 7.88124 12.2998 8.12749 12.2998C8.37376 12.2998 8.5741 12.0995 8.57408 11.8532V8.01897C8.57408 7.77272 8.37375 7.57239 8.12749 7.57239C7.88124 7.57239 7.68091 7.77272 7.68091 8.01897V11.8532Z"
        fill="black"
      />
      <path
        d="M9.82111 12.2988C9.83115 12.2995 9.84108 12.2998 9.85097 12.2998C10.0851 12.2998 10.2807 12.1166 10.2962 11.8827L10.5495 8.04842C10.5574 7.92938 10.5184 7.81441 10.4398 7.72469C10.3612 7.63496 10.2524 7.58122 10.1334 7.57336C9.88623 7.55716 9.67441 7.74576 9.65831 7.98952L9.40491 11.8237C9.3887 12.0695 9.57538 12.2826 9.82111 12.2988Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4794 14.4438H10.7754C11.077 14.4438 11.3654 14.3314 11.5875 14.1272C11.8095 13.923 11.9457 13.645 11.9709 13.3444L12.5258 6.72823C12.5538 6.39474 12.44 6.06218 12.2134 5.81586C11.9869 5.56951 11.6651 5.42822 11.3304 5.42822H4.92441C4.58974 5.42822 4.26785 5.56951 4.04132 5.81586C3.81479 6.0622 3.70093 6.39475 3.7289 6.72827L4.28389 13.3444C4.3091 13.645 4.44527 13.923 4.66731 14.1272C4.88934 14.3314 5.17773 14.4438 5.4794 14.4438ZM4.69879 6.42045C4.75667 6.35751 4.83891 6.32141 4.92442 6.32141H11.3304C11.4159 6.32141 11.4981 6.35749 11.556 6.42043C11.6139 6.48336 11.643 6.56834 11.6359 6.65356L11.0809 13.2697C11.0677 13.4272 10.9335 13.5506 10.7754 13.5506H5.47945C5.32133 13.5506 5.18716 13.4272 5.17397 13.2697L4.61897 6.65356C4.61182 6.56836 4.64091 6.48338 4.69879 6.42045Z"
        fill="black"
      />
    </svg>
  );
};

export default BadgeZeroWaste;
